<template>
  <b-modal :active.sync="isActive" has-modal-card trap-focus @close="$emit('close')">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Solicitar autorización</p>
        <button type="button" class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <b-message v-if="vigenciaInsufficientMessage" type="is-danger" has-icon>
          {{ vigenciaInsufficientMessage }}
        </b-message>
        <p class="mb-3"><strong>{{ contract.folio }}</strong> — {{ contract.organismo_nombre || contract.empresa_nombre }}</p>
        <p class="mb-4 is-size-7 has-text-grey">
          Se enviará un correo al Autorizador para que autorice la ampliación.
        </p>
        <b-field
          label="Tipo de ampliación"
          :type="errors.tipo ? 'is-danger' : null"
          :message="errors.tipo"
        >
          <b-select v-model="form.tipo" expanded :disabled="availableTypes.length < 2">
            <option v-for="tipo in availableTypes" :key="tipo" :value="tipo">{{ typeLabel(tipo) }}</option>
          </b-select>
        </b-field>
        <b-field
          label="Comentario (opcional)"
          :type="errors.comentario ? 'is-danger' : null"
          :message="errors.comentario"
        >
          <b-input v-model="form.comentario" type="textarea" maxlength="500"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" @click="close">Cerrar</button>
        <button class="button is-primary" :loading="loading" :disabled="!!vigenciaInsufficientMessage" @click="submit">Enviar solicitud</button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { availableExtensionTypes, EXTENSION_TYPE_LABELS, vigenciaExtensionInsufficientMessage } from './extensionNeeds';

export default {
  name: 'ContractSolicitarAmpliacionModal',
  props: {
    active: Boolean,
    contract: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      isActive: this.active,
      loading: false,
      errors: {},
      form: {
        tipo: 'presupuesto',
        comentario: ''
      }
    };
  },
  computed: {
    availableTypes() {
      return availableExtensionTypes(this.contract, true);
    },
    vigenciaInsufficientMessage() {
      if (this.form.tipo !== 'vigencia') {
        return '';
      }
      const porcentaje = this.contract.ampliacion_porcentajes?.vigencia ?? 20;
      return vigenciaExtensionInsufficientMessage(this.contract, porcentaje);
    }
  },
  watch: {
    active(val) {
      this.isActive = val;
      if (val) {
        this.resetForm();
      }
    },
    isActive(val) { if (!val) this.$emit('close'); }
  },
  methods: {
    resetForm() {
      this.errors = {};
      this.form = {
        tipo: this.availableTypes[0] || 'presupuesto',
        comentario: ''
      };
    },
    typeLabel(tipo) {
      return EXTENSION_TYPE_LABELS[tipo] || tipo;
    },
    close() {
      this.isActive = false;
      this.errors = {};
    },
    validateForm() {
      this.errors = {};
      if (!this.availableTypes.length) {
        this.errors.tipo = 'El contrato no requiere ampliación.';
        return false;
      }
      if (!this.form.tipo || !this.availableTypes.includes(this.form.tipo)) {
        this.errors.tipo = 'Seleccione el tipo de ampliación.';
        return false;
      }
      return true;
    },
    applyServerErrors(response) {
      const serverErrors = response?.data?.errors || {};
      Object.keys(serverErrors).forEach((key) => {
        const message = serverErrors[key];
        this.errors[key] = Array.isArray(message) ? message[0] : message;
      });
    },
    async submit() {
      if (!this.validateForm()) {
        this.$toast.error('Revise los datos de la solicitud.');
        return;
      }
      if (this.vigenciaInsufficientMessage) {
        this.errors.tipo = this.vigenciaInsufficientMessage;
        this.$toast.error(this.vigenciaInsufficientMessage);
        return;
      }

      this.loading = true;
      try {
        const payload = {
          tipo: this.form.tipo,
          comentario: (this.form.comentario || '').trim() || null
        };
        const { data } = await this.$http.post(
          `budget-control/contracts/${this.contract.id}/solicitar-ampliacion`,
          payload
        );
        this.$toast.success(data.message || 'Solicitud enviada al Autorizador.');
        this.$emit('saved');
        this.close();
      } catch ({ response }) {
        this.applyServerErrors(response);
        const serverErrors = response?.data?.errors || {};
        const detail = Object.values(serverErrors).flat().join(' ');
        this.$toast.error(detail || response?.data?.message || 'No se pudo enviar la solicitud.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
